import DocumentFile from '@/modules/documents/models/DocumentFile'
import { HttpService } from '@/shared/services'
const http = new HttpService()

export const getDocumentFilesByEmployeeId = async (employeeId: string) => {
  const response = await http.get<DocumentFile[]>(
    `policies/employee/${employeeId}`
  )
  return response.data
}
